/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, { useState, useCallback, useEffect } from 'react';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { PriceSlider } from './PriceSlider';
import { userService } from '../../../service/user.service';
import { createUrl } from '../../../redux/helper/CreateQuery';

function FilterModal({
    filterModal, setFilterModal, AreaWiseCustomerList, setAreaWiseCustomerList, Filter, setFilter, handleFilter, setfilterValue, filterValue, handleFetchAreaCustomerOutstandingReport, setpriceRange, priceRange, SetSuccessMessage,
}) {
    const [selectedType, setselectedType] = useState('area_name');
    const [areaSearchTerm, setAreaSearchterm] = useState('');
    const [territaryList, setterritaryList] = useState([]);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'area_name':
                if (Filter[key].length > 0) {
                    final += `&area_name=${createUrl(Filter[key])}`;
                }
                break;
            case 'area_total':
                if (priceRange.maxValue !== 0) {
                    final += `&area_total=${priceRange.minValue},${priceRange.maxValue}`;
                }
                break;
            default: break;
            }
            return final;
        });

        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filter(s) applied');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const handleClear = () => {
        setFilter({
            area_name: [],
        });
        setpriceRange((state) => ({
            ...state,
            maxValue: 0,
            minValue: 0,
        }));
        setfilterValue('');
        handleFetchAreaCustomerOutstandingReport();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const getTerritory = async () => {
        const arr2 = [];
        const territry = await userService.getTerritory();
        if (territry.data.data.length > 0) {
            setterritaryList(territry.data.data);
        }
        return arr2;
    };

    useEffect(() => {
        getTerritory();
    }, []);

    const areaSearchHandler = (areaValue) => {
        if (areaSearchTerm === '') {
            return areaValue;
        } if ((areaValue.NAME).toLowerCase().includes(areaSearchTerm.toLowerCase())) {
            return areaValue;
        }
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('area_name')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base ${selectedType === 'area_name' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-areaname"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profileVertical"
                                        role="tab"
                                        aria-controls="pills-profileVertical"
                                        aria-selected="false"
                                    >
                                        Area Name
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start my-4 w-full" role="presentation" onClick={() => setselectedType('area_total')}>
                                    <a
                                        href="#pills-profileareatotal"
                                        className={`nav-link block text-base ${selectedType === 'area_total' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="Area-total"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profileareatotal"
                                        role="tab"
                                        aria-controls="pills-profileareatotal"
                                        aria-selected="false"
                                    >
                                        Area Total
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'area_name' ? 'show active' : ''} fade px-3`} id="pills-profileVertical" role="tabpanel" aria-labelledby="pills-areaname">
                                    <div className="dropdown relative">
                                        <div className=" border rounded-t-[4px] border-[#D8D8D8] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                            <input
                                                className="text-sm46 font-normal h-[30px] w-[238px] outline-none text-[#808285] text-start  pl-1  pr-[32px] bg-[#FFFFFF]"
                                                placeholder="search"
                                                onChange={(e) => {
                                                    setAreaSearchterm((e.target.value));
                                                }}
                                            />
                                            <img src="/images/Group-279.svg" alt="icon" className="absolute top-[12px] right-[25px]" />
                                        </div>
                                        <ul className=" mt-3 h-[145px] w-[245px] overflow-y-auto scrollbar-menu overflow-x-hidden   z-[9999]">
                                            {territaryList.length > 0 && territaryList.filter((areaValue) => areaSearchHandler(areaValue)).map((ele) => (
                                                <li className="py-[8px]">
                                                    <div className="flex items-center pt-[2px] ">
                                                        <Checkbox
                                                            icon={
                                                                <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.area_name?.includes(ele?.NAME) ? '#555259' : ''}` }} />
                                                            }
                                                            name="my-input"
                                                            className="cursor-pointer"
                                                            checked={Filter.area_name?.includes(ele?.NAME)}
                                                            onChange={() => HandleFilter('area_name', ele?.NAME)}
                                                            borderColor={`${Filter.area_name?.includes(ele?.NAME) ? '#B8C5DC' : '#555259'}`}
                                                            style={{ cursor: 'pointer' }}
                                                            labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        />
                                                        <label htmlFor="mn50" className="consumbales pl-3 text-sm46 font-normal text-[#090406] text-left cursor-pointer">{ele?.NAME}</label>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'area_total' ? 'show active' : ''} fade px-3`} id="pills-profileareatotal" role="tabpanel" aria-labelledby="Area-total">
                                    <div className="relative">
                                        <div className=" flex justify-between">
                                            <p className="text-xs font-semibold text-[#000000]">₹ 5,000</p>
                                            <p className="text-xs font-semibold text-[#000000]">₹ 50,000</p>
                                        </div>
                                        <div className=" mt-2 mb-4">
                                            <div className="flex justify-center items-center">
                                                <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                                                    <div>
                                                        <PriceSlider setpriceRange={setpriceRange} priceRange={priceRange} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pt-3.5">
                                            <div className="px-1 flex items-center">
                                                <div className="relative w-1/2">
                                                    <input
                                                        onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                                        type="number"
                                                        id=""
                                                        value={priceRange.minValue}
                                                        onChange={(e) => setpriceRange((state) => ({
                                                            ...state,
                                                            minValue: e.target.value,
                                                        }))}
                                                        className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end"
                                                    />
                                                    <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                                                </div>
                                                <span className="text-xs6 font-semibold text-[#000000] px-5">-</span>
                                                <div className="relative w-1/2">
                                                    <input
                                                        onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}

                                                        onChange={(e) => setpriceRange((state) => ({
                                                            ...state,
                                                            maxValue: e.target.value,
                                                        }))}
                                                        type="number"
                                                        id=""
                                                        value={priceRange.maxValue}
                                                        className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end"
                                                    />
                                                    <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
